module.exports = __webpack_public_path__ + "static/media/settings icon (active).fd77e338.svg";